import angular from 'angular';

import { AddMemberModalComponent } from './components/add-member-modal.component';
import { ChangePasswordModalComponent } from './components/change-password-modal.component';
import { MembersComponent } from './components/members.component';

import { ChangePasswordModalService } from './services/change-password-modal.service';
import { MemberModalService } from './services/member-modal.service';
import { MemberService } from './services/member.service';

const members = angular.module('members',
    [
        'ngResource',
        'activities'
    ]
);

members.component('addMemberModal', AddMemberModalComponent);
members.component('changePasswordModal', ChangePasswordModalComponent);
members.component('members', MembersComponent);

members.service('ChangePasswordModal', ChangePasswordModalService);
members.service('MemberModal', MemberModalService);
members.service('Member', MemberService);

export const MembersModule = members;